import { makeStyles } from "@material-ui/core/styles";

const cardButtonStyles = makeStyles((theme) => ({
	root: {
		height: "100%"
	},
	card: {
		color: theme.palette.text.primary,
		height: "100%",
		borderRadius: ({ size }) => (size === "small" ? 4 : 8),
		background:
			"linear-gradient(333.43deg, rgba(0,0,0,0.1) 0%, rgba(255,255,255,0.1) 100%)",
		border: ({ active }) =>
			active ? "1px solid #fff" : "1px solid rgba(255,255,255,0.2)"
	},
	cardAction: {
		height: "100%"
	},
	cardContent: {
		height: "100%",
		padding: ({ size }) =>
			size === "small" ? "1vw" : "1.66vw 1.11vw 1.11vw 1.66vw"
	},
	actionText: {
		lineHeight: 1,
		fontWeight: ({ size }) => (size === "small" ? "normal" : "bold"),
		fontSize: ({ size }) => (size === "small" ? "1.11vw" : "1.4vw"),
		fontFamily: "Overpass",
		[theme.breakpoints.only("xs")]: {
			fontSize: "4vw !important"
		}
	},
	aspectRatioBox: {
		height: "100%",
		overflow: "hidden",
		paddingTop: ({ size, correctionFactor }) => {
			if (size === "medium") {
				return `calc(50% + ${correctionFactor}px)`;
			}
			if (size === "large") {
				return `calc(100% + ${correctionFactor}px)`;
			}
			return `calc(20% + ${correctionFactor}px)`;
		},
		position: "relative"
	},
	aspectRatioBoxInside: {
		position: "absolute",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%"
	},
	textContainer: {
		display: "flex",
		alignItems: ({ textAlign }) => textAlign,
		justifyContent: ({ textAlign }) => textAlign
	},
	iconContainer: {
		justifyContent: "flex-end",
		justifySelf: "flex-end",
		alignSelf: "flex-end",
		color: theme.palette.gameMode.primary,
		minHeight: "100%"
	},
	grid: {
		height: "100%",
		alignContent: ({ size }) => {
			return size === "small" ? "center" : "inherit";
		}
	}
}));

export default cardButtonStyles;
